import * as React from 'react';
import * as icons from '../Icons';
import { Button } from './Button';

export function MuteButton({ media }: { media: MediaStream }) {
  const [muted, setMuted] = React.useState(isMuted(media));

  const onClick = () => {
    toggleMute(media);
    setMuted((m) => !m);
  };

  return (
    <Button onClick={onClick}>
      {muted ? icons.MicOff(32) : icons.MicOn(32)}
    </Button>
  );
}

export function isMuted(media: MediaStream) {
  const track = media.getAudioTracks()[0];
  if (!track) {
    return true;
  }
  return !track.enabled;
}

export function toggleMute(media: MediaStream) {
  const track = media.getAudioTracks()[0];
  if (!track) {
    return;
  }
  track.enabled = !track.enabled;
}
